import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import AnnouncementModal from './Dashboard/Announcements/AnnouncementModal';
import { get } from 'lodash';
import queryString from 'query-string';

import Bob from './Bob';
import Esms from './Esms';
import WebSocketConnection from './Global/WebSocketConnection';

import * as BobActions from '../actions/bobActions';
import * as CompanyInfoActions from '../actions/companyInfoActions';
import * as CoreActions from '../actions/coreActions';
import * as CurrentUserActions from '../actions/currentUserActions';
import * as dashboardActions from '../actions/dashboardActions';

const AppSwitch = ({
    activeNavCompany,
    companies,
    companyInfo,
    currentUser,
    fetchApiVersion,
    fetchCompanies,
    fetchCompanyInfo,
    fetchNavClients,
    announcement,
    history,
    initUser,
    instanceId,
    isSignedIn,
    session,
    setNavCompany,
    signIn,
    signOut,
    targetNavCompany,
    fetchAnnouncementMessages,
    ...props
}) => {
    const [ queryParams, setQueryParams ] = useState();
    const [ firstTimeUser, setFirstTimeUser ] = useState(false);
    const [ companyId, setCompanyId ] = useState(null);
    const [ selectedAnnouncement, setselectedAnnouncement ] = useState({});
    const [ showMsg, setShowMsg ] = useState(false);

    const handleClose = () => {
        setShowMsg(false);
    };

    useEffect(() => {
        const init = async () => {
            await fetchCompanies();
            fetchApiVersion();
            if (!currentUser.defaultCompany) {
                await initUser();
            }
        };

        setQueryParams(queryString.parse(history.location.search));

        let returnUrl = sessionStorage.getItem('returnUrl');

        if (returnUrl) {
            sessionStorage.removeItem('returnUrl');
            history.push(returnUrl);
            setQueryParams(queryString.parse(history.location.search));
        }

        init();

    }, []);

    useEffect(() => {
        if (currentUser.email && !currentUser.defaultCompany) {
            setFirstTimeUser(true);
        }
    }, [currentUser]);

    useEffect(() => {
        if (announcement && announcement.id) {
            setselectedAnnouncement(announcement);
            setShowMsg(true);
        }
    }, [announcement]);


    useEffect(() => {
        const initCompanyInfo = async targetCompany => {
            await fetchCompanyInfo(targetCompany);
        };

        if (companies.length) {
            let defaultCompany, targetCompany;

            if (queryParams && queryParams.company) {
                targetCompany = companies.find(company => {
                    return company.company.id === queryParams.company;
                });
            }

            defaultCompany = companies.find(company => {
                return company.company.id === currentUser.defaultCompany;
            });

            if (!defaultCompany && companies.length) {
                defaultCompany = companies[0];
                // eslint-disable-next-line no-console
                console.log(`Could not find default company. Connecting to ${companies[0].company.name}`);
            }

            if (targetCompany) {
                const companyId = get(targetCompany, 'company.id', null);

                sessionStorage.setItem('companyId', companyId);
                initCompanyInfo(targetCompany);
            } else if (defaultCompany) {
                const companyId = get(defaultCompany, 'company.id', null);
                sessionStorage.setItem('companyId', companyId);
                initCompanyInfo(defaultCompany);
            } else {
                sessionStorage.setItem('companyId', '');
                history.push('/myaccount');
            }
        } else {
            sessionStorage.setItem('companyId', '');
        }
    }, [companies]);

    useEffect(() => {
        if (companyInfo.companyName) {
            setNavCompany({
                name: companyInfo.companyName,
                id:   companyInfo.companyId
            });
            setCompanyId(companyInfo.companyId);
        }
    }, [companyInfo]);

    useEffect(() => {
        if (activeNavCompany.id) {
            setCompanyId(activeNavCompany.id);
        }
    }, [activeNavCompany]);

    return (
        <React.Fragment>
            <WebSocketConnection
                companyId={companyId}
                idToken={session.idToken.jwtToken}
                instanceId={instanceId}
            />
            <Switch>
                <Redirect
                    from="/reporting/inspectionReports"
                    to="/v2/dashboard/reports"
                />
                <Redirect
                    from="/home"
                    to="/"
                />
                <Route
                    path="/v2"
                    render={(routeProps) => (
                        <Bob
                            {...routeProps}
                            signIn={signIn}
                            signOut={signOut}
                            isSignedIn={isSignedIn}
                            currentUser={currentUser}
                            firstTimeUser={firstTimeUser}
                        />
                    )}
                />
                <Route
                    path="/"
                    render={(routeProps) => (
                        <Esms
                            {...routeProps}
                            signIn={signIn}
                            signOut={signOut}
                            isSignedIn={isSignedIn}
                            firstTimeUser={firstTimeUser}
                        />
                    )}
                />
                {
                    process.env.executiveSummaryEnabled ?
                        <Redirect from="/" to="/v2/dashboard/executivesummary" />
                        :
                        process.env.isBobLandingEnabled ?
                            <Redirect from="/" to="/v2/dashboard/company" />
                            :
                            null
                }
            </Switch>

            { showMsg?
                <AnnouncementModal
                    title={selectedAnnouncement.title}
                    selectedAnnouncement={selectedAnnouncement}
                    open={showMsg}
                    close={handleClose}
                />:''
            }
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    companies:        state.core.companies,
    companyInfo:      state.companyInfo,
    currentUser:      state.currentUser,
    instanceId:       state.auth.instanceId,
    session:          state.auth.session,
    announcement:     state.dashboard.announcement
});

const mapDispatchToProps = {
    ...BobActions,
    ...CompanyInfoActions,
    ...CoreActions,
    ...CurrentUserActions,
    ...dashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppSwitch));
